import {Component, Input} from '@angular/core';
import {SnackbarService} from '../../service/snackbar.service';

@Component({
    selector: 'ui-kit-copy-button',
    templateUrl: './copy-button.component.html',
    styleUrls: ['./copy-button.component.scss'],
    standalone: false,
})
export class CopyButtonComponent {
    @Input({required: true}) copyText: string;
    @Input({required: true}) label: string;
    @Input({required: true}) copiedLabel: string;

    constructor(private snackbarService: SnackbarService) {
    }

    onCopySuccess(): void {
        this.snackbarService.showSnackBar(this.copiedLabel, 'success');
    }
}
